import RedirectPage from '@common/components/redirect/redirectPage';

const Redirect = [
  {
    path: '/',
    name: 'Redirect',
    component: RedirectPage,
  },
];

export default Redirect;
